import { IconClock as TablerIconClock } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconClock = /*#__PURE__*/ createOutlineIcon(TablerIconClock, 'IconClock');
